<script lang="ts">
import { onMount } from "svelte";
import { writable } from "svelte/store";
import { token, checkToken, logout } from "./api";
import { activePage } from "./router";

import Login from "./views/Login.svelte";
import Browser from "./views/Browser.svelte";
import Users from "./views/Users.svelte";
import Status from "./views/Status.svelte";
import Logout from "./views/Logout.svelte";
import Blacklist from "./views/Blacklist.svelte";
import Playground from "./views/Playground.svelte";

const views = {
	login:      Login,
	browser:    Browser,
	users:      Users,
	status:     Status,
	logout:     Logout,
	blacklist:  Blacklist,
	playground: Playground,
};

let lastToken = $token;
token.subscribe((value) => {
	if (!lastToken && value) {
		$activePage = "browser";
	} else if (lastToken && !value) {
		$activePage = "login";
	}
	lastToken = value;
});

function go (e) {
	e.preventDefault();
	let next = e.target.href.replace(/.*\/(.+)$/, "$1")

	if (next !== "login" && !$token) {
		next = "login";
	}

	$activePage = next;
}

onMount(async ( ) => {
	if ($token) {
		if (await checkToken()) {
			$activePage = "browser";
		}
	}
});
</script>


<nav class="navbar navbar-expand-lg navbar-dark bg-primary">
	<div class="container-fluid">
		<a class="navbar-brand" href="browser" on:click="{go}">OGonline <small>Media Server</small></a>

		<div class="collapse navbar-collapse">
			<ul class="navbar-nav me-auto mb-2 mb-lg-0">
				<li class="nav-item">
					<a href="browser" class="nav-link" class:active="{$activePage === "browser"}" on:click="{go}">Browser</a>
				</li>
				<li class="nav-item">
					<a href="users" class="nav-link" class:active="{$activePage === "users"}" on:click="{go}">Users</a>
				</li>
				<li class="nav-item">
					<a href="status" class="nav-link" class:active="{$activePage === "status"}" on:click="{go}">Status</a>
				</li>
				<li class="nav-item">
					<a href="blacklist" class="nav-link" class:active="{$activePage === "blacklist"}" on:click="{go}">Blacklist</a>
				</li>
				<li class="nav-item">
					<a href="playground" class="nav-link" class:active="{$activePage === "playground"}" on:click="{go}">Playground</a>
				</li>
			</ul>

			<ul class="navbar-nav">
			{#if !$token}
				<li class="nav-item" class:active="{$activePage === "login"}">
					<a href="login" class="nav-link" on:click="{go}">Log in</a>
				</li>
			{:else}
				<li class="nav-item" class:active="{$activePage === "logout"}">
					<a href="logout" class="nav-link" on:click|preventDefault="{logout}">Log out</a>
				</li>
			{/if}
			</ul>
		</div>
	</div>
</nav>

<div class="container-fluid app-container">
	<div class="row">
		<div class="col">
			<svelte:component this={views[$activePage]}></svelte:component>
		</div>
	</div>
</div>

